/**
 * topdog-cci-combined-page.js
 *
 * TopDog + CCI Pullback combined strategy:
 *   Fires when TopDog (SMA50 slope + Stoch(5,2,3) %K extreme) and CCI Pullback
 *   (SMA50 slope + CCI excursion/pullback) both trigger for the same coin,
 *   timeframe, and direction. Daily + 4H only — CCI Pullback has no weekly variant.
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchTopDogCciCombinedData } from '../services/server-api';

const TF_LABELS = { daily: 'Daily', fourHour: '4H' };

function renderDetails(entry) {
  const stochKVal  = entry.stochFastK != null ? entry.stochFastK.toFixed(1) : '—';
  const cciVal     = entry.cci != null ? entry.cci.toFixed(1) : '—';
  const slopeLabel = entry.sma50Slope === 'up' ? '↑ rising' : '↓ falling';
  return (
    <>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">SMA50</span>
        <span className="mtf-ind-value zone">{slopeLabel}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">Stoch(5,2,3) %K</span>
        <span className="mtf-ind-value zone">{stochKVal}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">CCI(20)</span>
        <span className="mtf-ind-value zone">{cciVal}</span>
      </div>
    </>
  );
}

function TopDogCciCombinedPage() {
  return (
    <StrategySignalsPage
      config={{
        title:      'ProjectTD + CCI Combined',
        icon:       '🔗',
        subtitle:   'Fires when ProjectTD and CCI Pullback both trigger on the same coin and timeframe',
        fetchFn:    fetchTopDogCciCombinedData,
        timeframes: ['daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default TopDogCciCombinedPage;
